/**
 * @flow
 * @relayHash 73065e2efe1746127962c95114d4d77a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BillingAddressCreateInput = {|
  address: string,
  isDefault: boolean,
  countryId: string,
  governorateId: string,
  cityId: string,
  customerId?: ?string,
|};
export type CreateBillingAddressMutationVariables = {|
  data: BillingAddressCreateInput
|};
export type CreateBillingAddressMutationResponse = {|
  +createBillingAddress: {|
    +id: string
  |}
|};
export type CreateBillingAddressMutation = {|
  variables: CreateBillingAddressMutationVariables,
  response: CreateBillingAddressMutationResponse,
|};
*/


/*
mutation CreateBillingAddressMutation(
  $data: BillingAddressCreateInput!
) {
  createBillingAddress(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "BillingAddressCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createBillingAddress",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "BillingAddressModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateBillingAddressMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateBillingAddressMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateBillingAddressMutation",
    "id": null,
    "text": "mutation CreateBillingAddressMutation(\n  $data: BillingAddressCreateInput!\n) {\n  createBillingAddress(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '67d29f717f8ef7530bc7805b6b0b24bc';
module.exports = node;
